import { Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { Calendar } from 'primeng/calendar';
import { Dropdown } from 'primeng/dropdown';
import { UserLogService } from '../../../main-layout/userLog/userLog.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VALIDATION_PATTERNS } from 'src/app/views/utility/validation-patterns';
import { Utilityservice } from 'src/app/views/utility/utilityservice.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BaseClass } from 'src/app/views/utility/baseClass';

@Component({
  selector: 'app-userlogfilters',
  templateUrl: './userlogfilters.component.html',
  styleUrls: ['./userlogfilters.component.css']
})
export class UserlogfiltersComponent extends BaseClass implements OnInit {
  ref: DynamicDialogRef;
  index_value: any;
  locationList: any[];
  departmentList: any[];
  userList: any[];
  logtypeList: any[];
  user: any;
  location: any;
  department: any;

  @ViewChild('dropdown') dropdown: Dropdown;
  @ViewChild('p-calendar') calendar: Calendar;

  maxLabelWidth: number;
  @Output() dataEvent = new EventEmitter<{}>();
  _selectedColumns: any;
  cols: any;
  today: Date;
  todaysDate: Date = new Date();
logtypeerrorDIsplay: any;
  // UserlogForm: FormGroup;
  // ngOnInit() {
  //   // this.formInitiliaze();
  //   // this.UserlogForm.markAllAsTouched();
  //   this.today = new Date();
  //   const threeMonthsAgo = new Date();
  //   threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
  //   const fromDate = moment(threeMonthsAgo).format('DD-MMM-YYYY');
  //   const toDate  = moment(this.todaysDate).format('DD-MMM-YYYY');
  //   // this.UserlogForm.get('from_date')?.setValue(fromDate);
  //   // this.UserlogForm.get('to_date')?.setValue(toDate);
  // this.filterinput = {
  //   ...this.filterinput,
  //   from_date: fromDate,
  //   to_date: toDate
  // };
  //     // this.UserlogForm.markAllAsTouched();
  //     //  console.log('Form Values After Init:', this.UserlogForm.value);
  // }
  // formInitiliaze() {
  //       this.today = new Date();
  //   const threeMonthsAgo = new Date();
  //   threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
  //   const fromDate = moment(threeMonthsAgo).format('DD-MMM-YYYY');
  //   const toDate  = moment(this.todaysDate).format('DD-MMM-YYYY');
  //   this.UserlogForm = this.fb.group({
  //     logtype: ['', Validators.compose([
  //       Validators.required,
  //     ])],
  //     department: [''],
  //     location: [''],
  //     user: [''],
  //     from_date: [fromDate],
  //     to_date: [toDate]
  //   })
  // }
  ngOnInit() {
  this.today = new Date();

  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 1);

  this.filterinput = {
    ...this.filterinput,
    from_date: threeMonthsAgo,
    to_date: new Date()
  };
    this.logtypeerrorDIsplay = true;
  this.updateFilters();
}

updateFilters() {

  this.fromdateerrorDisplay = false;
  this.todateerrorDIsplay = false;
  this.errorDIsplay = false;

  const fromDate = this.filterinput.from_date;
  const toDate = this.filterinput.to_date;

  if (!fromDate && !toDate) {
    this.filtersData.from_date = '';
    this.filtersData.to_date = '';
  } 
  else {

    if (!fromDate) {
      this.fromdateerrorDisplay = true;
    }

    if (!toDate) {
      this.todateerrorDIsplay = true;
    }

    if (fromDate && toDate && moment(fromDate).isAfter(moment(toDate))) {
      this.errorDIsplay = true;
      return;
    }

    this.filtersData.from_date = fromDate ? moment(fromDate).format('DD-MMM-YYYY') : '';
    this.filtersData.to_date = toDate ? moment(toDate).format('DD-MMM-YYYY') : '';
  }
  if(this.filterinput.logtype=="6"){
  this.filtersData.sortField = "senton";}
  else if(this.filterinput.logtype=="2"||this.filterinput.logtype=="1"){
  this.filtersData.sortField = "createdon";}
  this.userlogService.getFilterChange(this.filtersData);
  this.getDropdownList();
}

  getTextWidth(text: string): number {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = '14px Arial'; // You may need to adjust the font size
    const width = context.measureText(text).width;
    return width;
  }

  @Input() componentname: string = "";

  errorDIsplay = false;
  isround: boolean = true
  filtresParams = [];
  filterinput: Filterreq = new Filterreq();
  filtersData: Filterreq = new Filterreq();
  constructor(private userlogService: UserLogService, public override injector: Injector,
    public config: DynamicDialogConfig,
    private utilityservice: Utilityservice,
    private spinnerservice: NgxSpinnerService,
    private el: ElementRef
  ) {
    super(injector);
    this.getDropdownList();
    this.userlogService.getFilterChange(this.filtersData);
    // this.formInitiliaze();
  }
  // validation_message = {
  //   'logtype': [{ type: 'required', message: 'Please select Log Type' }]
  // }
  todateerrorDIsplay = false;
  fromdateerrorDisplay = false;
  isDateChanged = false;
  
  validateDates() {

  this.fromdateerrorDisplay = false;
  this.todateerrorDIsplay = false;
  this.errorDIsplay = false;
  this.isDateChanged = true;

  const fromDate = this.filterinput.from_date;
  const toDate = this.filterinput.to_date;

  if (!fromDate) {
    this.fromdateerrorDisplay = true;
    return;
  }

  if (!toDate) {
    this.todateerrorDIsplay = true;
    return;
  }

if (moment(fromDate).isAfter(moment(toDate))) {
  this.errorDIsplay = true;
  return;
}
}
  getlogtypeTooltip(): string {
    const selectedId = this.filterinput.logtype;
    if (!selectedId) {
      return 'Select Log Type';
    }
    const selected = this.logtypeList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Log Type';
  }

  getuserTooltip(): string {
    const selectedId = this.filterinput.user;
    if (!selectedId) {
      return 'Select User';
    }
    const selected = this.userList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select User';
  }

  getlocationTooltip(): string {
    const selectedId = this.filterinput.location;
    if (!selectedId) {
      return 'Select Location';
    }
    const selected = this.locationList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Location';
  }

  getdepartmentTooltip(): string {
    const selectedId = this.filterinput.department;
    if (!selectedId) {
      return 'Select Department';
    }
    const selected = this.departmentList.find(opt => opt.value === selectedId);
    return selected ? selected.labelname : 'Select Department';
  }

  getDropdownList() {
    var user_list = this.userlogService.get_user(this.filtersData);
    user_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.username.localeCompare(b.username);
      });
      this.userList = res.map(e => ({ labelname: e.username, value: e.userid }));
      this.userList.unshift({ labelname: 'Select', value: "" })
    });
    var location_list = this.userlogService.get_location(this.filtersData);
    location_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.locationname.localeCompare(b.locationname);
      });
      this.locationList = res.map(e => ({ labelname: e.locationname, value: e.locationid }));
      this.locationList.unshift({ labelname: 'Select', value: "" })
    });
    var logType = this.userlogService.get_log_type();
    logType.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.logtypename.localeCompare(b.logtypename);
      });
      this.logtypeList = res.map(e => ({ labelname: e.logtypename, value: e.logtypeid }));
      this.logtypeList.unshift({ labelname: 'Select', value: "" })
    });
    var department_list = this.userlogService.get_department(this.filtersData);
    department_list.subscribe(res => {
      res.sort((a, b) => { //for sort elements
        return a.departmentname.localeCompare(b.departmentname);
      });
      this.departmentList = res.map(e => ({ labelname: e.departmentname, value: e.departmentid }));
      this.departmentList.unshift({ labelname: 'Select', value: "" })
    });

  }

  getdatetooltip(type) {
    if (type == 'from') {
      if (!this.filterinput.from_date) {
        return 'Select From Date';
      }
      return this.formatDate(this.filterinput.from_date, 'DD-MMM-YYYY');
    }
    else {
      if (!this.filterinput.to_date) {
        return 'Select To Date';
      }
      return this.formatDate(this.filterinput.to_date, 'DD-MMM-YYYY');
    }
  }

  onclear(event) {
    this.fromdateerrorDisplay = false;
    this.todateerrorDIsplay = false;
    if (event.from_date == null && event.to_date == null) {
      this.errorDIsplay = false;
       this.fromdateerrorDisplay = false;
       this.todateerrorDIsplay = false;
      this.filtersData['from_date'] = ''; this.filtersData['to_date'] = '';
    }

    if (!event.from_date && event.to_date) {
      this.fromdateerrorDisplay = true;

      this.filtersData['from_date'] = '';
    }
    if (!event.to_date && event.from_date) {
      this.todateerrorDIsplay = true;

      this.filtersData['to_date'] = '';
    }
    this.userlogService.getFilterChange(this.filtersData);
  }

  // onFilterSelect(event) {
  //   if (this.UserlogForm.invalid) {
  //     this.UserlogForm.markAllAsTouched();
  //     return;
  //   }
  //   Object.keys(this.filterinput).forEach(key => {
  //     if (this.filterinput[key] === undefined || this.filterinput[key] === null) {
  //       this.filterinput[key] = '';
  //     }
  //   });
  //   this.filtersData = event;
  //   this.userlogService.getFilterChange(this.filtersData);
  //   this.getDropdownList();
  // }

onFilterSelect() {
  if(this.filterinput.logtype!=""){
    this.logtypeerrorDIsplay = false;
  }
  Object.keys(this.filterinput).forEach(key => {
    if (this.filterinput[key] === undefined || this.filterinput[key] === null) {
      this.filterinput[key] = '';
    }
  });

  this.filtersData = { ...this.filterinput };
  this.updateFilters();
  this.getDropdownList();
}

  getdates(event) { 
    const fromDate = this.filterinput.from_date;
    const toDate = this.filterinput.to_date;
    if (fromDate) {
      this.filtersData.from_date = moment(fromDate).format('DD-MMM-YYYY');
      // this.filtersData.to_date = moment(toDate).format('DD-MMM-YYYY');
    } else {
      this.filtersData.from_date = '';
      // this.filtersData.to_date = '';
    }
    if (toDate) {
      this.filtersData.to_date = moment(toDate).format('DD-MMM-YYYY');
      // this.filtersData.to_date = moment(toDate).format('DD-MMM-YYYY');
    } else {
      this.filtersData.to_date = '';
      // this.filtersData.to_date = '';
    }
    this.userlogService.getFilterChange(this.filtersData);

    this.validateDates();
  }

  refreshFilters() {
    window.location.reload();
    // this.errorDIsplay = false;
    // this.filterinput = new Filterreq();
    // this.filtersData = new Filterreq();
    // this.filtersData['page'] = 1;
    // this.filtersData['size'] = 10;
    // this.getDropdownList();
    // this.userlogService.getFilterChange(this.filtersData);
    // this.userlogService.filterrefresh();
    // this.todateerrorDIsplay = false;
    // this.fromdateerrorDisplay = false;
  }

}
export class Filterreq {
  location = "";
  department = "";
  logtype = "";
  user = "";
  from_date: any = '';
  to_date: any = '';
  page = 1;
  size = 10;
  sortField = '';
}



